Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var greyAnthilia = {
  50: '#ecedea',
  100: '#d0d2cc',
  200: '#b1b4aa',
  300: '#919587',
  400: '#7a7f6e',
  500: '#626854',
  600: '#5a604d',
  700: '#505543',
  800: '#474b3d',
  900: '343a29#',
  'contrastDefaultColor': 'light',
};

var _default = greyAnthilia;
exports.default = _default;